namespace Matrix.Rebalancer {
    export interface TaskTypePropertiesRow {
        TaskTypeCode?: string;
        PropertyName?: string;
        PropertyGroup?: string;
        Description?: string;
        DataType?: string;
        MinLength?: number;
        MaxLength?: number;
        MinValue?: number;
        MaxValue?: number;
        ListCode?: string;
        ListType?: string;
        ReadOnly?: boolean;
        Required?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TaskTypeName?: string;
        TaskTypeRowId?: number;
    }

    export namespace TaskTypePropertiesRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'TaskTypeCode';
        export const localTextPrefix = 'Rebalancer.TaskTypeProperties';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            TaskTypeCode = "TaskTypeCode",
            PropertyName = "PropertyName",
            PropertyGroup = "PropertyGroup",
            Description = "Description",
            DataType = "DataType",
            MinLength = "MinLength",
            MaxLength = "MaxLength",
            MinValue = "MinValue",
            MaxValue = "MaxValue",
            ListCode = "ListCode",
            ListType = "ListType",
            ReadOnly = "ReadOnly",
            Required = "Required",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TaskTypeName = "TaskTypeName",
            TaskTypeRowId = "TaskTypeRowId"
        }
    }
}
